// @ts-nocheck
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AiOutlineCalculator } from "react-icons/ai";
import { RiLockPasswordLine } from "react-icons/ri";
import { BiUser } from "react-icons/bi";
import {
  faBars,
  faMessage,
  faMultiply,
  faQuestionCircle,
} from "@fortawesome/free-solid-svg-icons";
import Loader from "../../loader/Loader";
import {
  FaBars,
  FaChevronDown,
  FaChevronUp,
  FaMinus,
  FaPlus,
  FaPowerOff,
} from "react-icons/fa";
import {
  error_toaster,
  success_toaster,
} from "../../toaster/Toaster";
import { PostApi } from "../../../ApiClient/PostApi";
import { faComments } from "@fortawesome/free-solid-svg-icons";

export default function Header() {
  const [toggle, setToggle] = useState(true);
  const showNav = () => {
    setToggle(false);
  };
  const hideNav = () => {
    setToggle(true);
  };
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const logout = async (e) => {
    e.preventDefault();
    setLoader(true);
    const res = await PostApi("users/logout", {
      accessToken: localStorage.getItem("accessToken"),
    });

    if (res.data.status === "1") {
      success_toaster(res.data.message);
      setLoader(false);
      localStorage.removeItem("LoginStatus");
      localStorage.removeItem("BearerToken");
      navigate("/login");
    } else {
      error_toaster(res.data.message);
      setLoader(false);
    }
  };
  const [dropdown, setDropdown] = useState(false);
  const toggleD = () => {
    setDropdown(true);
  };
  const toggleBackD = () => {
    setDropdown(false);
  };
  if (loader) {
    return <Loader />;
  } else {
    return (
      <header className="bg-themeBlue h-20 flex items-center relative z-50">
        <nav className="2xl:w-3/4 xl:w-[85%] w-11/12 mx-auto flex items-center justify-between py-2">
          <div>
            <Link to="/">
              <img src="/images/logo.webp" alt="logo" className="w-40" />
            </Link>
          </div>
          <div>
            <ul
              className={`lg:flex ${
                toggle ? "hidden" : "flex"
              } lg:flex-row flex-col lg:static absolute left-0 top-20 
                lg:w-auto w-full lg:items-center xl:gap-x-10 lg:gap-x-6 gap-y-4 text-white font-medium xl:text-xl 
                text-lg lg:bg-transparent bg-black bg-opacity-80 lg:pt-0 pt-3 lg:pb-0 pb-6 lg:px-0 px-8`}
            >
              <li>
                <Link
                  to="/package_details"
                  className="flex items-center lg:gap-x-2 gap-x-3"
                >
                  <AiOutlineCalculator size={24} />
                  <span>Get a Quote</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/getting_started"
                  className="flex items-center lg:gap-x-2 gap-x-3"
                >
                  <FontAwesomeIcon icon={faQuestionCircle} className="w-5" />
                  <span>Help & Guide</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/faq"
                  className="flex items-center lg:gap-x-2 gap-x-3"
                >
                  <FontAwesomeIcon icon={faComments} className="w-5" />
                  <span>FAQ</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/support"
                  className="flex items-center lg:gap-x-2 gap-x-3"
                >
                  <FontAwesomeIcon icon={faMessage} className="w-5" />
                  <span>Chat to Us</span>
                </Link>
              </li>
              {/* <li>
                <Link to="" className="flex items-center lg:gap-x-2 gap-x-3">
                  <FontAwesomeIcon icon={faMessage} className="w-5" />
                  <span>Chat to Us</span>
                </Link>
              </li> */}
              {localStorage.getItem("LoginStatus") === "true" ? (
                <>
                  <li className="relative">
                    <div className="lg:block flex items-center justify-between">
                      <button
                        onClick={dropdown ? toggleBackD : toggleD}
                        className="bg-themeRed px-3 py-2 rounded border border-themeRed 
                hover:bg-white hover:text-themeRed hover:border-white lg:flex hidden  
                  items-center gap-x-3"
                      >
                        <div className="border-2 bg-white border-white rounded-fullest p-1">
                          <span className="text-themeRed">
                            {localStorage
                              .getItem("firstName")
                              .charAt(0)
                              .toUpperCase()}
                            {localStorage
                              .getItem("lastName")
                              .charAt(0)
                              .toUpperCase()}
                          </span>
                        </div>
                        <span>
                          {localStorage.getItem("firstName")}{" "}
                          {/* {localStorage.getItem("lastName")} */}
                        </span>
                        <span className="lg:block hidden">
                          {dropdown ? <FaChevronUp /> : <FaChevronDown />}
                        </span>
                      </button>
                      <button
                        className="bg-themeRed px-3 py-2 rounded border border-themeRed 
                hover:bg-white hover:text-themeRed hover:border-white lg:hidden flex items-center 
                  gap-x-3"
                      >
                        <div className="border-2 border-white rounded-fullest">
                          <img
                            src="images/arsel.jpeg"
                            alt="user"
                            className="w-8 h-8 object-cover rounded-fullest"
                          />
                        </div>
                        <span>Arsel T</span>
                        <span className="lg:block hidden">
                          {dropdown ? <FaChevronUp /> : <FaChevronDown />}
                        </span>
                      </button>
                      <span
                        className="lg:hidden block"
                        onClick={dropdown ? toggleBackD : toggleD}
                      >
                        {dropdown ? <FaMinus /> : <FaPlus />}
                      </span>
                    </div>
                    <div
                      className={`lg:absolute relative mt-2 bg-white min-w-full text-black text-opacity-80 py-3 px-3 
                  text-xl rounded
                  ${dropdown ? "block" : "hidden"}`}
                    >
                      <ul className="[&>li]:cursor-pointer hover:[&>li]:text-themeRed space-y-2">
                        <li>
                          <Link
                            to="/dashboard"
                            className="flex items-center lg:gap-x-2 gap-x-4"
                          >
                            <FaBars size={20} />
                            <span>Dashboard</span>
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/change_password"
                            className="flex items-center lg:gap-x-2 gap-x-4"
                          >
                            <RiLockPasswordLine size={20} />
                            <span>Change Password</span>
                          </Link>
                        </li>
                        <li>
                          <Link
                            to={`/update_profile/${localStorage.getItem(
                              "userId"
                            )}`}
                            className="flex items-center lg:gap-x-2 gap-x-4"
                          >
                            <BiUser size={20} />
                            <span>Update Profile</span>
                          </Link>
                        </li>
                        <li>
                          <button
                            onClick={logout}
                            className="flex items-center lg:gap-x-2 gap-x-4"
                          >
                            <FaPowerOff size={20} />
                            <span>Logout</span>
                          </button>
                        </li>
                      </ul>
                    </div>
                  </li>
                </>
              ) : (
                <Link
                  to="/login"
                  className="bg-themeRed px-3 py-2 rounded border border-themeRed 
                            hover:bg-white hover:text-themeRed hover:border-white"
                >
                  Login/Signup
                </Link>
              )}
            </ul>
          </div>
          <div className={`lg:hidden ${toggle ? "block" : "hidden"}`}>
            <button className="text-white" onClick={showNav}>
              <FontAwesomeIcon icon={faBars} />
            </button>
          </div>
          <div className={`lg:hidden ${toggle ? "hidden" : "block"}`}>
            <button className="text-white" onClick={hideNav}>
              <FontAwesomeIcon icon={faMultiply} />
            </button>
          </div>
        </nav>
      </header>
    );
  }
}
